import { CanActivate, Route } from "@angular/router";

import PagesDetails from "@assets/constantes/pages-details.json";

import { FeatureFlagGuard } from "@shared/Guards/feature-flag-guard";
import { UserHasPermissionGuard } from "@shared/Guards/user-has-permission.guard";

export const getRouteSection =
  (section: string) =>
  (pageName: string, customCanActivate?: CanActivate[]): Partial<Route> => {
    return getRouteDetails(`${section}.${pageName}`, customCanActivate);
  };

export const getRouteDetails = (pageName: string, customCanActivate?: CanActivate[]): Partial<Route> => {
  const { title, permission, featureFlag } = getObjectPathByString(pageName, PagesDetails);

  let canActivate = [];

  if (customCanActivate) {
    canActivate = customCanActivate;
  } else {
    featureFlag && canActivate.push(FeatureFlagGuard);
    permission && canActivate.push(UserHasPermissionGuard);
  }

  return {
    canActivate,
    data: {
      title,
      feature: featureFlag,
      requiredPermission: permission,
    },
  };
};

const getObjectPathByString = (path: string, object: Record<string, any>): any => {
  return path.split(".").reduce((acc, current) => acc[current], object);
};
